import React from 'react';
import SuperAdminLayout            from './SuperAdminLayout';
import SuperAdminDashboardPage     from './SuperAdminDashboardPage';
import SuperAdminFirmPage          from './SuperAdminFirmPage';
import SuperAdminRevenuePage       from './SuperAdminRevenuePage';
import SuperAdminAdminsPage        from './SuperAdminAdminsPage';
import SuperAdminActivityPage      from './SuperAdminActivityPage';
import SuperAdminAnnouncementsPage from './SuperAdminAnnouncementsPage';
import SuperAdminNotificationsPage from './SuperAdminNotificationsPage';
import SuperAdminDemoRequestsPage  from './SuperAdminDemoRequestsPage';
import SuperAdminDemoViewsPage     from './SuperAdminDemoViewsPage';
import SuperAdminHealthPage        from './SuperAdminHealthPage';
import { useRoute, matchRoute } from '../../lib/router';

function SuperAdminRouter() {
  const [{ pathname, segments }] = useRoute();

  const firmDetail = matchRoute(segments, 'superadmin/firms/:id');
  if (firmDetail) return <SuperAdminFirmPage firmId={firmDetail.id} />;

  switch (pathname) {
    case '/superadmin/revenue':       return <SuperAdminRevenuePage />;
    case '/superadmin/admins':        return <SuperAdminAdminsPage />;
    case '/superadmin/activity':      return <SuperAdminActivityPage />;
    case '/superadmin/announcements':  return <SuperAdminAnnouncementsPage />;
    case '/superadmin/notifications':  return <SuperAdminNotificationsPage />;
    case '/superadmin/demo-requests':  return <SuperAdminDemoRequestsPage />;
    case '/superadmin/demo-views':     return <SuperAdminDemoViewsPage />;
    case '/superadmin/health':         return <SuperAdminHealthPage />;
    case '/superadmin':
    case '/superadmin/firms':
    default:
      return <SuperAdminDashboardPage />;
  }
}

export default function SuperAdminApp() {
  return (
    <SuperAdminLayout>
      <SuperAdminRouter />
    </SuperAdminLayout>
  );
}
